import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login'
// import Index from '@/pages/index'
// import Order from '@/pages/order/order'
import searchPriceH5 from '@/pages/searchPriceH5.vue'; // 导入新组件
import modelValuation from '@/pages/modelValuation/modelValuation.vue'; // 导入新组件
// import qualityInspection from '@/pages/qualityInspection.vue'; // 导入新组件



Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === "development" ? "/exchange-man-manager": "/",
  routes: [
    { path: '/', 
      redirect: { name: '/login' }
    },
    {
      path: '/login',
      name: '/login',
      component: Login,
      meta: {
        title: '登录'
      },
    },
    {
      path: '/searchPrice',
      name: 'searchPrice',
      component: searchPriceH5 // 将新组件关联到路由
    },
    {
      path: '/modelValuation',
      name: 'modelValuation',
      component: modelValuation // 将新组件关联到路由
    },
    // {
    //   path: '/index/qualityInspection',
    //   name: 'qualityInspection',
    //   component: qualityInspection // 将新组件关联到路由
    // },
  ]
})
